// extracted by mini-css-extract-plugin
export default {"container":"StatsHeader_container__zs4ui","description":"StatsHeader_description__5g8Pq"};